

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

function floatRightOpen() {
    $(".floatright__main").removeClass("active");
    $(".close_floatright").removeClass("active");
}

function floatRightClose() {
    $(".floatright__main").addClass("active");
    $(".close_floatright").addClass("active");
}

window.addEventListener("load", function () {
    $(".MS__sprite-btn-closefloatright").on("click", function (e) {
        e.stopPropagation();
        $(".floatright__main").toggleClass("active");
        $(".close_floatright").toggleClass("active");
    });

    var headerEl = document.getElementById("cfl-ms-25-header");
    if (headerEl) {
        var headerObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    floatRightOpen();
                } else {
                    floatRightClose();
                }
            });
        }, { threshold: 0.1 });

        headerObserver.observe(headerEl);
    }
});
